export default __webpack_public_path__ + "static/media/creq-chef.83ae1307.svg";